import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const STYLE_LINK_ID = 'usp-route-based-styles';
const baseUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '') || '';

// public 폴더 내의 실제 경로와 일치해야 합니다.
const BIZ_CSS_HREF = `${baseUrl}/biz/css/import.css`;
const AIBIZ_CSS_HREF = `${baseUrl}/aiBiz/css/import.css`;

// information 관련 css가 별도로 있다면 경로 확인 필요. 없다면 AIBIZ_CSS_HREF 사용
// const INFORMATION_CSS_HREF = `${baseUrl}/aiBiz/import.css`;

/**
 * - /biz 경로: public/biz/css/ 폴더의 CSS만 적용 (import.css 로드) 사업관리
 * - 그 외 경로: public/aiBiz/css/ 폴더의 CSS만 적용 (import.css 로드) 기업지원
 */
export function RouteBasedStyles() {
  const { pathname } = useLocation();

  // /biz 로 시작하는 경로는 BIZ 스타일 적용
  const isBiz = pathname.startsWith('/biz');

  // information 경로에 대한 처리가 필요하다면 추가 (현재는 aiBiz와 동일하게 처리하거나 별도 처리)
  // const isInformation = pathname.includes('information');

  useEffect(() => {
    const head = document.head;
    let link = document.getElementById(STYLE_LINK_ID) as HTMLLinkElement | null;

    // 경로에 따라 적용할 CSS 파일 결정
    const targetHref = isBiz ? BIZ_CSS_HREF : AIBIZ_CSS_HREF;

    if (link) {
      // 이미 링크 태그가 존재하고, href가 다르면 교체
      // getAttribute('href')를 사용하여 현재 설정된 값과 정확히 비교
      if (link.getAttribute('href') !== targetHref) {
        link.href = targetHref;
      }
    } else {
      // 링크 태그가 없으면 새로 생성하여 추가
      link = document.createElement('link');
      link.id = STYLE_LINK_ID;
      link.rel = 'stylesheet';
      link.href = targetHref;
      head.appendChild(link);
    }

    // 추가적으로 aiBiz/biz 스타일 충돌 방지를 위해
    // 만약 다른 방식으로 로드된 aiBiz/biz 스타일이 있다면 제거하는 로직을 여기에 추가할 수도 있음.
    // (이전 Header.tsx에서 했던 로직과 유사)

  }, [isBiz]); // isBiz 상태가 변경될 때만 실행

  return null;
}
